"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getRawHelpData = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _constants = require("./constants");

var _models = require("./models");

var getHelpServicesUri = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(index) {
    var _context, _context2;

    var base;
    return _regenerator.default.wrap(function _callee$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _environment.getRoute)('HelpServices');

          case 2:
            base = _context3.sent;
            return _context3.abrupt("return", (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(base)).call(_context2, _constants.helpServicesUri)).call(_context, index));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee);
  }));

  return function getHelpServicesUri(_x) {
    return _ref.apply(this, arguments);
  };
}();

var makeRequest = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(query, index) {
    var uri, body, myHeaders, request, response;
    return _regenerator.default.wrap(function _callee2$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getHelpServicesUri(index);

          case 2:
            uri = _context4.sent;
            body = (0, _stringify.default)(query);
            myHeaders = new Headers();
            myHeaders.append('Accept', 'application/json');
            myHeaders.append('Content-Type', 'application/json');
            request = new Request(uri, {
              method: 'POST',
              body: body,
              headers: myHeaders
            });
            _context4.next = 10;
            return fetch(request);

          case 10:
            response = _context4.sent;
            return _context4.abrupt("return", response.json());

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee2);
  }));

  return function makeRequest(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var setSort = function setSort(sortNames, sortDirs) {
  var _context6;

  var sort = [];

  if (sortNames && sortNames.length > 0) {
    (0, _forEach.default)(sortNames).call(sortNames, function (name, i) {
      var _context5;

      var sortObj = {};
      var order = {
        order: (sortDirs === null || sortDirs === void 0 ? void 0 : sortDirs[i]) ? sortDirs[i] : _models.SortDir.Desc
      };
      sortObj[name] = order;
      sort = (0, _concat.default)(_context5 = []).call(_context5, (0, _toConsumableArray2.default)(sort), [sortObj]);
    });
  }

  sort = (0, _concat.default)(_context6 = []).call(_context6, (0, _toConsumableArray2.default)(sort), ['_score']);
  return sort;
};

var setQuery = function setQuery(tcData, screens, sortNames, sortDirs) {
  var sort = setSort(sortNames, sortDirs);
  var query = {
    sort: sort,
    query: {
      bool: {
        must: [{
          match: {
            screens: screens.join(' | ')
          }
        }, {
          match: {
            oCountry: tcData.oCountry
          }
        }, {
          match: {
            oLang: tcData.oLang
          }
        }, {
          match: {
            oUserType: tcData.oUserType
          }
        }]
      }
    }
  };

  if (tcData.oApp && tcData.oApp.length > 0) {
    query.query.bool.must.push({
      match: {
        oApp: tcData.oApp.join(' | ')
      }
    });
  }

  return query;
};

var getRawHelpData = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(data) {
    var query;
    return _regenerator.default.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            query = setQuery(data.tcData, data.screens, data.sortNames, data.sortDirs);
            return _context7.abrupt("return", makeRequest(query, data.index));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3);
  }));

  return function getRawHelpData(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getRawHelpData = getRawHelpData;
